module.exports = __webpack_public_path__ + "img/banner01_zh-CN.e35a238a.jpg";